export default {
  qmulusMaterialSelected: 'Sie haben einen Qmulus-Werkstoff ausgewählt. Die Analysewerte werden gespeichert, der Werkstoffname jedoch nicht.',
  pt9800MaterialSelected: 'Sie haben einen PT9800-Werkstoff ausgewählt. Seine Analyse kann nicht geändert werden.',
};
